import { useEffect, useState } from "react";
import { ExternalLink, Headphones } from "lucide-react";
import { api } from "@/lib/api";

const buildEmbedSrc = (url, color = "#181e14") => {
  const encodedColor = color.replace("#", "%23");
  return `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=${encodedColor}&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true`;
};

export const SoundcloudEmbed = () => {
  const [playlists, setPlaylists] = useState([]);

  useEffect(() => {
    api.get("/catalog/soundcloud").then((r) => setPlaylists(r.data)).catch(() => {});
  }, []);

  if (playlists.length === 0) return null;

  return (
    <div className="space-y-6" data-testid="catalog-soundcloud-list">
      {playlists.map((p) => (
        <div
          key={p.id}
          className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#141419]"
          data-testid={`catalog-soundcloud-band-${p.id}`}
        >
          <div className="p-3 sm:p-4">
            <iframe
              title={p.title || "SoundCloud playlist"}
              data-testid={`catalog-soundcloud-player-${p.id}`}
              src={buildEmbedSrc(p.url, p.color || "#181e14")}
              width="100%"
              height="450"
              frameBorder="0"
              scrolling="no"
              allow="autoplay; encrypted-media"
              loading="lazy"
              style={{ borderRadius: 12 }}
            />
          </div>
          <div className="flex items-center justify-between gap-4 border-t border-white/10 px-5 py-3">
            <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-emerald-200">
              <Headphones size={12} /> {p.title || "Underground Takeover"}
            </p>
            <a
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`catalog-soundcloud-open-${p.id}`}
              className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wider text-zinc-400 transition-colors hover:text-emerald-200"
            >
              Open on SoundCloud <ExternalLink size={11} />
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};
